<script setup lang="ts">
import ExternalMaterialIcon from '@/assets/icons/ExternalMaterialIcon.vue';
import WebIcon from '@/assets/icons/WebIcon.vue';

/** Stands in for a material's logo; the parent sets the box size. */
defineProps<{
  /** A material a teacher added (not from the catalog). */
  custom: boolean;
  largeIcon?: boolean;
}>();
</script>

<template>
  <span
    :class="[
      'flex shrink-0 items-center justify-center rounded-lg border border-surface-secondary bg-white',
      custom ? 'text-black' : 'text-secondary',
    ]"
  >
    <ExternalMaterialIcon v-if="custom" :class="largeIcon ? 'size-icon-md' : 'size-icon-xs'" />
    <WebIcon v-else class="size-icon-md" />
  </span>
</template>
